import React from "react";

const Home = () => {
  return (
    <>
      <main data-barba="container" data-barba-namespace="home">
        <div className="min-svh-100 d-flex align-items-center justify-content-center  px-3 px-sm-4 px-md-5 opacity-load">
          <div className="container">
            <div className="spacer"></div>
            <div className="mt-5 pt-3 w-full">
              <h1 className="animate-blur big">
                <span className="flex text-center">Connect Wallet</span>{" "}
                <span>to</span> <span>Acquire Brains</span>
              </h1>
            </div>
            <div className="spacer"></div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Home;
